import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";

const SearchEngine = (props) => {
    document.title = "Search Engine";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [seoData, setSeoData] = useState({})
    const [searchFeatureData, setSearchFeatureData] = useState('')
    const [lightHouseDesktopData, setLightHouseDesktopData] = useState({
        columns: [
            {
                label: 'Performance Audit Type',
                field: 'audit',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Score',
                field: 'score',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Display Value',
                field: 'displayValue',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Description',
                field: 'description',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Details',
                field: 'details',
                sort: 'asc',
                width: 150
            },
        ]
    })

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Search Engine", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Search Engine", breadcrumbItems)
    })

    useEffect(() => {
        const getLHDScanList = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEARCH_ENGINE_LHD_SCAN}/${scanId}`)
                data.data = data.data.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setLightHouseDesktopData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data
                }))
            } catch (e) {
                console.error(e);
            }
        }
        getLHDScanList()
    }, [scanId])

    useEffect(() => {
        const fetchSeoData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEO_SCAN}/${scanId}`)
                const valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
                setSeoData(valid)
            } catch (e) {
                console.error(e);
            }
        }
        fetchSeoData()
    }, [scanId])

    useEffect(() => {
        const fetchSearchFeature = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEARCH_FEATURE_SCAN}/${scanId}`)
                if (data.status)
                    setSearchFeatureData(data.data['Search Type'])
            } catch (e) {
                console.error(e);
            }
        }
        fetchSearchFeature()
    }, [])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <TableHeader scanName={"Search Enabled?"} />
                        <CardBody style={{
                            backgroundColor: searchFeatureData === 'no search' ? 'rgb(254, 202, 202)' : 'rgb(202, 254, 206)',
                            color: searchFeatureData === 'no search' ? '#a70000' : '#00a70b'
                        }}
                        >
                            <span
                                style={{
                                    fontSize: '20px',
                                }}
                            >
                                {searchFeatureData === 'no search' ? 'No' : searchFeatureData}
                            </span>
                        </CardBody>
                    </Card>
                    <Card>
                        <TableHeader scanName={"Light House Desktop"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {lightHouseDesktopData && lightHouseDesktopData.rows && (
                                <DataTableWithPopup noBottomColumns={false} thirdPartyData={lightHouseDesktopData} />
                            )}
                        </CardBody>
                    </Card>
                    <Card>
                        <TableHeader scanName={"Seo"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {seoData && seoData.rows && (
                                <DataTableWithPopup noBottomColumns thirdPartyData={seoData} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(SearchEngine)